import {h, Component} from 'preact';
import {$CONTENT_WINDOW} from '@config/selectors';

export default class ScrollToTop extends Component {

    componentDidMount() {
        this.contentScroller = document.querySelector( $CONTENT_WINDOW );

        this.setScroll();
    }

    componentDidUpdate( prevProps ) {
        if ( this.props.location !== prevProps.location ) {
            this.setScroll();
        }
    }

    setScroll() {
        window.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        if ( this.contentScroller ) {
            this.contentScroller.scrollTop = 0;
        }
    }

    render( {children} ) {
        return <div className="scrollToTop">{children}</div>
    }
}